import React from 'react'

import { Relative } from '../helpers/Position'

const CanvasContext = React.createContext()
export const useCanvas = () => React.useContext(CanvasContext)

const Canvas = ({ children, disabled }) => {
  const ref = React.useRef()
  const [width, setWidth] = React.useState(0)
  React.useEffect(() => {
    if (ref.current) setWidth(ref.current.offsetWidth)
  }, [])

  return (
    <div className="canvas" ref={ref}>
      <CanvasContext.Provider value={{ width, disabled }}>
        <Relative height="100%" flex={1} margin={-0.4} zIndex={0} minHeight={150}>
          {children}
        </Relative>
      </CanvasContext.Provider>
    </div>
  )
}

export default Canvas
